module.exports = __webpack_public_path__ + "static/media/archana.ff72bdd1.jpg";